module.exports = __webpack_public_path__ + "img/logo_antaranews.a955f03b.png";